import _classCallCheck from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @module ol/format/JSONFeature
 */
import FeatureFormat from './Feature.js';
import { abstract } from '../util.js';
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for JSON feature formats.
 *
 * @abstract
 */

var JSONFeature = /*#__PURE__*/function (_FeatureFormat) {
  _inherits(JSONFeature, _FeatureFormat);

  var _super = _createSuper(JSONFeature);

  function JSONFeature() {
    _classCallCheck(this, JSONFeature);

    return _super.call(this);
  }
  /**
   * @return {import("./Feature.js").Type} Format.
   */


  _createClass(JSONFeature, [{
    key: "getType",
    value: function getType() {
      return 'json';
    }
    /**
     * Read a feature.  Only works for a single feature. Use `readFeatures` to
     * read a feature collection.
     *
     * @param {ArrayBuffer|Document|Element|Object|string} source Source.
     * @param {import("./Feature.js").ReadOptions} [options] Read options.
     * @return {import("../Feature.js").default} Feature.
     * @api
     */

  }, {
    key: "readFeature",
    value: function readFeature(source, options) {
      return this.readFeatureFromObject(getObject(source), this.getReadOptions(source, options));
    }
    /**
     * Read all features.  Works with both a single feature and a feature
     * collection.
     *
     * @param {ArrayBuffer|Document|Element|Object|string} source Source.
     * @param {import("./Feature.js").ReadOptions} [options] Read options.
     * @return {Array<import("../Feature.js").default>} Features.
     * @api
     */

  }, {
    key: "readFeatures",
    value: function readFeatures(source, options) {
      return this.readFeaturesFromObject(getObject(source), this.getReadOptions(source, options));
    }
    /**
     * @abstract
     * @param {Object} object Object.
     * @param {import("./Feature.js").ReadOptions} [options] Read options.
     * @protected
     * @return {import("../Feature.js").default} Feature.
     */

  }, {
    key: "readFeatureFromObject",
    value: function readFeatureFromObject(object, options) {
      return abstract();
    }
    /**
     * @abstract
     * @param {Object} object Object.
     * @param {import("./Feature.js").ReadOptions} [options] Read options.
     * @protected
     * @return {Array<import("../Feature.js").default>} Features.
     */

  }, {
    key: "readFeaturesFromObject",
    value: function readFeaturesFromObject(object, options) {
      return abstract();
    }
    /**
     * Read a geometry.
     *
     * @param {ArrayBuffer|Document|Element|Object|string} source Source.
     * @param {import("./Feature.js").ReadOptions} [options] Read options.
     * @return {import("../geom/Geometry.js").default} Geometry.
     * @api
     */

  }, {
    key: "readGeometry",
    value: function readGeometry(source, options) {
      return this.readGeometryFromObject(getObject(source), this.getReadOptions(source, options));
    }
    /**
     * @abstract
     * @param {Object} object Object.
     * @param {import("./Feature.js").ReadOptions} [options] Read options.
     * @protected
     * @return {import("../geom/Geometry.js").default} Geometry.
     */

  }, {
    key: "readGeometryFromObject",
    value: function readGeometryFromObject(object, options) {
      return abstract();
    }
    /**
     * Read the projection.
     *
     * @param {ArrayBuffer|Document|Element|Object|string} source Source.
     * @return {import("../proj/Projection.js").default} Projection.
     * @api
     */

  }, {
    key: "readProjection",
    value: function readProjection(source) {
      return this.readProjectionFromObject(getObject(source));
    }
    /**
     * @abstract
     * @param {Object} object Object.
     * @protected
     * @return {import("../proj/Projection.js").default} Projection.
     */

  }, {
    key: "readProjectionFromObject",
    value: function readProjectionFromObject(object) {
      return abstract();
    }
    /**
     * Encode a feature as string.
     *
     * @param {import("../Feature.js").default} feature Feature.
     * @param {import("./Feature.js").WriteOptions} [options] Write options.
     * @return {string} Encoded feature.
     * @api
     */

  }, {
    key: "writeFeature",
    value: function writeFeature(feature, options) {
      return JSON.stringify(this.writeFeatureObject(feature, options));
    }
    /**
     * @abstract
     * @param {import("../Feature.js").default} feature Feature.
     * @param {import("./Feature.js").WriteOptions} [options] Write options.
     * @return {Object} Object.
     */

  }, {
    key: "writeFeatureObject",
    value: function writeFeatureObject(feature, options) {
      return abstract();
    }
    /**
     * Encode an array of features as string.
     *
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {import("./Feature.js").WriteOptions} [options] Write options.
     * @return {string} Encoded features.
     * @api
     */

  }, {
    key: "writeFeatures",
    value: function writeFeatures(features, options) {
      return JSON.stringify(this.writeFeaturesObject(features, options));
    }
    /**
     * @abstract
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {import("./Feature.js").WriteOptions} [options] Write options.
     * @return {Object} Object.
     */

  }, {
    key: "writeFeaturesObject",
    value: function writeFeaturesObject(features, options) {
      return abstract();
    }
    /**
     * Encode a geometry as string.
     *
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {import("./Feature.js").WriteOptions} [options] Write options.
     * @return {string} Encoded geometry.
     * @api
     */

  }, {
    key: "writeGeometry",
    value: function writeGeometry(geometry, options) {
      return JSON.stringify(this.writeGeometryObject(geometry, options));
    }
    /**
     * @abstract
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {import("./Feature.js").WriteOptions} [options] Write options.
     * @return {Object} Object.
     */

  }, {
    key: "writeGeometryObject",
    value: function writeGeometryObject(geometry, options) {
      return abstract();
    }
  }]);

  return JSONFeature;
}(FeatureFormat);
/**
 * @param {Document|Element|Object|string} source Source.
 * @return {Object} Object.
 */


function getObject(source) {
  if (typeof source === 'string') {
    var object = JSON.parse(source);
    return object ?
    /** @type {Object} */
    object : null;
  } else if (source !== null) {
    return source;
  } else {
    return null;
  }
}

export default JSONFeature;